<mat-card class="filter settingHeader">
  <div class="name">
    Manage NTA
  </div>
</mat-card>

<div class="documents">

  <div>
    <button mat-flat-button color="primary" style="float: right; margin-right: 27px; margin-bottom: 5px;"  (click)="UpdateNTAJsonInBlob()">Save</button>
    <br />
    <textarea id="ntatxtarea" [(ngModel)]="ntaJsonData" (input)="adjustHeight($event.target)"  style="width:98%;height:90%;"></textarea>
    <br />
    <button mat-flat-button color="primary" style="float: right; margin-right: 27px; margin-bottom: 5px;"    (click)="UpdateNTAJsonInBlob()">Save</button>
  </div>
</div>

<app-loader></app-loader>
